<template>
  <div v-if="loading" class="dialysis-page">
    <loader />
  </div>
  <div v-if="!loading" class="dialysis-page">
    <div class="header">
      <h2>Dialysis Treatment Session</h2>
      <p v-if="!sessionStarted" class="status pending">Session not started</p>
      <p v-if="sessionStarted && !sessionEnded" class="status ongoing">
        Session ongoing
      </p>
      <p v-if="sessionEnded" class="status ended">Session ended</p>
    </div>

    <div class="patient-info">
      <h3>Patient Details</h3>
      <div class="info-grid">
        <p><strong>Name:</strong> {{ patient.name }}</p>
        <p><strong>Age:</strong> {{ getAge(patient.dob) }} yrs</p>
        <p>
          <strong>Gender:</strong> {{ patient.gender == 1 ? "Male" : "Female" }}
        </p>
        <p><strong>OPD No:</strong> {{ patient.opd }}</p>
        <p v-if="sessionStarted">
          <strong>Ward:</strong> {{ session_data.ward_name }}
        </p>
        <p v-if="sessionStarted">
          <strong>Bed No:</strong> {{ session_data.bed_number }}
        </p>
        <p v-if="sessionStarted">
          <strong>Machine:</strong> {{ session_data.machine_number }}
        </p>
        <!-- <p><strong>Allergies:</strong> {{ session_data.notes }}</p> -->
      </div>
    </div>
    <div v-if="!sessionStarted || !sessionEnded">
      <div v-if="sessionStarted" class="timer-section">
        <h3>Time on Dialysis Machine</h3>
        <!-- <span>{{ progressPercent }}</span> -->
        <p>
          <strong>Session Start Time:</strong> {{ real_date(sessionStartTime) }}
        </p>
        <div class="progress-bar">
          <!-- <div class="progress" :style="{ width: progressPercent + '%' }"></div> -->

          <div
            class="progress"
            :class="progressClass"
            :style="{ width: progressPercent + '%' }"
          ></div>
        </div>
        <div class="time-info">
          <p><strong>Elapsed:</strong> {{ elapsedTime }}</p>
          <p><strong>Remaining:</strong> {{ remainingTime }}</p>
        </div>
      </div>

      <div class="controls">
        <button v-if="!sessionStarted" @click="startSession" class="btn start">
          Start Session
        </button>
        <!-- <button
        v-if="sessionStarted && !sessionEnded"
        @click="stopSession"
        class="btn stop"
      >
        End Session
      </button> -->
      </div>

      <div v-if="sessionStarted && !sessionEnded" class="actions-section">
        <h3>Dialysis Actions</h3>
        <div class="btn-group"></div>

        <!-- test -->
        <div class="btn-group">
          <button class="btn vitals" @click="show_vitals_modal">
            Take Vitals
          </button>
          <!-- <button class="btn vitals" @click="showStartSessionModal = true">
          📄 Start Session Details
        </button> -->
          <button class="btn orange" @click="showFluidModal = true">
            💧 Log Fluid Balance
          </button>
          <button class="btn green" @click="showParamsModal = true">
            ⚙️ Machine Parameters
          </button>
          <button class="btn orange" @click="showComplicationsModal = true">
            ⚠️ Complications / Events
          </button>
          <button class="btn vitals" @click="showConsumablesModal = true">
            📝 Consumables Used
          </button>
          <button class="btn stop" @click="showEndSessionModal = true">
            🛑 End Session Data
          </button>
        </div>
        <!-- end test -->
      </div>
    </div>

    <div v-if="sessionEnded" class="summary-section">
      <h3>Session Summary</h3>
      <p>
        <strong>Total Elapsed Time:</strong>
        {{ dialysis_end_session_data.elapsed_time }} min
      </p>

     
    </div>
    <DialysisSummary
      :session_id="session_id"
      :procedure_data="procedure_data"
      :key="componentKey"
    />
  </div>
  <!--  -->
  <start_dialysis_session_modal
    :visit_id="insearch_visit"
    :patient="patient"
    v-if="showStartSessionModal"
    @close-start-session-modal="hide_start_session_modal"
  />

  <FluidBalanceModal
    v-if="showFluidModal"
    :session_id="session_id"
    :start_time="session_data.start_time"
    @close-fluid-balance-modal="showFluidModal = false"
    @save-log="handleFluidSave"
  />
  <MachineParametersModal
    v-if="showParamsModal"
    :session_id="session_id"
    @close-machine-parameters-modal="showParamsModal = false"
    @save-params="handleMachineParams"
  />

  <ComplicationsModal
    v-if="showComplicationsModal"
    :session_id="session_id"
    @close-complications-modal="showComplicationsModal = false"
    @save-complications="handleComplications"
  />

  <ConsumablesModal
    v-if="showConsumablesModal"
    :is_dialysis="true"
    :conducted_record="session_data"
    @hide-consumables-model="showConsumablesModal = false"
    @save-consumables="handleConsumablesSave"
  />

  <EndSessionModal
    v-if="showEndSessionModal"
    :session_id="session_id"
    @close-end-session-modal="showEndSessionModal = false"
    @save-session="handleEndSessionData"
  />

  <TakeVitalsModal
    v-if="showModalTakeVitals"
    @close="handleCloseTakeVitalsModel()"
    :visit_id="insearch_visit"
  />
</template>

<script>
import loader from "./loader.vue";
import formatDateTime from "../../../timezone/utc_local_time";
import DialysisSummary from "./dialysis_summary.vue";
import EndSessionModal from "./end_session_data.vue";
// import ConsumablesModal from "./consumables_modal.vue";
import ConsumablesModal from "../../visits_management/lab/ConsumablesModal.vue";
import ComplicationsModal from "./complications_modal.vue";
import FluidBalanceModal from "./fluid_balance_tracking_modal.vue";
import start_dialysis_session_modal from "./start_dialysis_session_modal.vue";
import MachineParametersModal from "./machine_parameters_modal.vue";
import TakeVitalsModal from "../../Patients/components/take_vitals_modal.vue";
import { generalApiRequest } from "../../../api/apiIndex";
import getAge from "../../../timezone/dob_to_age";
import calculateProgressImport from "./bar_calculator";
export default {
  name: "DialysisTreatment",
  data() {
    return {
      loading: false,
      sessionStarted: false,
      sessionEnded: false,
      patient: {},
      totalDialysisTimeSec: 4 * 3600, // 4 hours in seconds
      elapsedTime: 0, // in seconds
      timer: null,
      sessionStartTime: "",
      activities: [],
      consumablesUsed: ["Dialyser FX80", "Heparin 5000 IU", "Saline 500ml"],
      session_data: {},
      progressPercent: 0,
      remainingTime: 0,
      procedure_data: {},
      componentKey: 0,
      session_id: "",
      dialysis_end_session_data: {},

      //
      insearch_visit: this.$route.params.visitid,

      showStartSessionModal: false,
      showFluidModal: false,
      showParamsModal: false,
      showComplicationsModal: false,
      showConsumablesModal: false,
      showEndSessionModal: false,
      showModalTakeVitals: false,
    };
  },
  components: {
    start_dialysis_session_modal,
    FluidBalanceModal,
    MachineParametersModal,
    ComplicationsModal,
    ConsumablesModal,
    EndSessionModal,
    TakeVitalsModal,
    DialysisSummary,
    loader,
    // table_page_layout
  },

  computed: {},
  methods: {
    real_date(date) {
      return formatDateTime(date);
    },
    progressPercent_() {
      this.progressPercent = this.calculateProgress(this.sessionStartTime);

      if (this.progressPercent < 50) this.progressClass = "low";
      else if (this.progressPercent < 80) this.progressClass = "mid";
      else this.progressClass = "high";
    },
    getAge,
    show_vitals_modal() {
      this.showModalTakeVitals = true;
    },
    handleCloseTakeVitalsModel() {
      this.showModalTakeVitals = false;
    },
    startSession() {
      console.log("this session");

      this.showStartSessionModal = true;
    },
    hide_start_session_modal() {
      this.showStartSessionModal = false;
      this.get_session_details(); // refresh without reload
    },
    async get_patient_n_visit() {
      const url = "get_patient_object_from_visit/" + this.insearch_visit;
      const resp = await generalApiRequest(url, "GET", {}, 1);
      this.patient = resp.data;
    },

    async get_session_details() {
      try {
        this.loading = true;
        const url = "get_dialysis_session/" + this.insearch_visit;
        const resp = await generalApiRequest(url, "GET", {}, 1);
        this.session_data = resp.data;
        this.session_id = resp.data.id;
        this.dialysis_end_session_data = resp.dialysis_end_session_data;
        this.procedure_data = resp;
        this.sessionEnded = this.session_data.completed;
        //
        // console.log(resp);
        this.componentKey++;

        if (this.session_data && this.session_data.start_time) {
          this.sessionStarted = true;
          this.sessionStartTime = this.session_data.start_time;
          if (this.timer) {
            clearInterval(this.timer);
          }

          this.progressPercent_();
          this.timer = setInterval(() => {
            this.elapsedTime++;
            this.progressPercent_();
          }, 1000);
        } else {
          this.sessionStarted = false;
          this.sessionStartTime = null;
          this.elapsedTime = 0;
        }

        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },

    async stopSession() {
      clearInterval(this.timer);
      await generalApiRequest(
        `end_dialysis_session/${this.insearch_visit}`,
        "POST",
        {},
        1
      );
      this.sessionEnded = true;
    },
    recordActivity(activity) {
      this.activities.push(`${activity} at ${new Date().toLocaleTimeString()}`);
    },
    formatTime(seconds) {
      const hrs = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${this.pad(hrs)}:${this.pad(mins)}:${this.pad(secs)}`;
    },
    pad(val) {
      return val.toString().padStart(2, "0");
    },

    // ----------------------------------------------------------------------------------------------------------------------
    calculateProgress(strt) {
      var returns = calculateProgressImport(strt);

      this.elapsedTime = returns.elapsedTimeFormatted;
      this.remainingTime = returns.remainingTimeFormatted;

      return returns.progressPercent;
    },
    // ---------------------------------------------------------------------------------------------------------------------
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  mounted() {
    this.get_patient_n_visit();
    this.get_session_details();

    console.log(this.progressPercent);
  },
};
</script>

<style scoped>
.progress.low {
  background: #28a745;
}
.progress.mid {
  background: #fd7e14;
}
.progress.high {
  background: #dc3545;
}

.dialysis-page {
  max-width: 1200px;
  margin: 30px auto;
  padding: 20px;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.header {
  text-align: center;
  margin-bottom: 20px;
}

.status {
  font-size: 18px;
  font-weight: 600;
  margin-top: 5px;
}
.status.pending {
  color: #999;
}
.status.ongoing {
  color: #007bff;
}
.status.ended {
  color: #28a745;
}

h2,
h3,
h4 {
  margin-bottom: 10px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
  margin-bottom: 10px;
}
.patient-info {
  background-color: #fbf8ef;
}

.progress-bar {
  width: 100%;
  background: #e4e4e4;
  height: 25px;
  border-radius: 5px;
  overflow: hidden;
}

.progress {
  height: 100%;
  background: #4caf50;
  transition: width 0.4s ease;
}

.time-info {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}

.btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.btn {
  padding: 10px 16px;
  border: none;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.start {
  background: #28a745;
}
.stop {
  background: #dc3545;
}
.vitals {
  background: #007bff;
}
.green {
  background: #17a2b8;
}
.orange {
  background: #fd7e14;
}

.controls {
  text-align: center;
  margin-bottom: 20px;
}

/* ends style for data presentation */
</style>
